export default __webpack_public_path__ + "static/media/Hamilton_Sundstrand.33401933.png";